import React from 'react';

import { useClientContext } from '@client/lib/ClientContext';
import { getWebApp } from '@client/lib/Telegram';

import type { ILayoutPageProps } from './LayoutPage.typings';
import { cnLayoutPage } from './LayoutPage.const';

import './LayoutPage.scss';

export const LayoutPage: React.FC<ILayoutPageProps> = props => {
    const [{ theme }] = useClientContext();

    React.useEffect(() => {
        getWebApp().setHeaderColor(theme === 'dark' ? '#221d22' : '#f7f8fa');
    }, [theme]);

    return (
        <div className={cnLayoutPage(null, [props.className])}>
            {props.children}
        </div>
    );
};
